<template>
  <div class="import-jobs">
    <div class="add-jobs" v-show="!objectId">
      <el-input placeholder="Поиск ..." v-model="search" class="input-search">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
      <el-table
        row-key="id"
        @select="handleSelectionChangeObject"
        @select-all="handleSelectionChangeObject"
        empty-text="Объекты не найдены"
        ref="multipleObjectTable"
        :data="filteredList"
        style="width: 100%"
      >
        <el-table-column
          property="check"
          type="selection"
          width="55"
        >
        </el-table-column>
        <el-table-column
          property="name"
          label="Объекты"
        >
        </el-table-column>
        <el-table-column
          width="50px"
        >
          <template slot-scope="scope">
            <i class="fa fa-edit" @click="selectObject(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="add-jobs" v-show="objectId" v-loading="loading">
      <el-input placeholder="Поиск ..." v-model="jobSearch" class="input-search">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
      <div class="jobs-ul">

        <el-table
          @selection-change="handleSelectionChangeJob"
          empty-text="Работы не найдены"
          ref="jobsTable"
          @row-click="rowClickJob"
          :data="filteredJobs"
          style="width: 100%"
        >
          <el-table-column
            property="check"
            type="selection"
            width="55"
          ></el-table-column>
          <el-table-column
            label="Работы"
          >
            <template slot-scope="scope">
              <div>
                <div class="name-slot">
                  <span>{{ scope.row.name }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="create-footer">
      <el-button @click="back" v-if="objectId">Назад</el-button>
      <el-button @click="save" type="primary">Сохранить</el-button>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import _ from 'lodash';
import {getChildList} from '../../../../utils/getChild';
import {v4 as uuidv4} from 'uuid';
import {getPermission, getPermissionByUser} from "../../../../firestore/permission";
import {filterObjects} from "../../../../utils/filterJobs";

export default {
  name: 'PermissionObject',
  props: ['name', 'onlyPlan', 'id', 'planId', 'versionId'],
  data() {
    return {
      search: '',
      jobSearch: '',
      dialogObject: false,
      objectId: null,
      selectedObjects: [],
      selectedJob: [],
      loading: false,
      availableJobs: {},
      availableObjects: [],
      list: [],
      jobs: [],
      jobsData: []
    };
  },
  computed: {
    filteredList() {
      return this.list.filter(object => {
        return object.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    filteredJobs() {
      let filteredJobs = [...this.jobs];

      if (this.onlyPlan) {
        filteredJobs = filteredJobs.filter(({_data}) => !!_data.plan)
      }

      return filteredJobs.filter(object => {
        return object.name.toLowerCase().includes(this.jobSearch.toLowerCase());
      }) || [];
    },
  },

  watch: {
    filteredList: _.debounce(function () {
      this.filteredList.map((row) => {
        const availableObjects = this.availableObjects.map((a) => a.id);
        if (availableObjects.includes(row.id)) {
          this.$refs.multipleObjectTable.toggleRowSelection(row);
        }
      })
    }, 200),
    filteredJobs: _.debounce(function () {
      this.filteredJobs.map((row) => {
        const availableJobs1 = (this.availableJobs[this.objectId] || []).map((a) => a.id);

        if (availableJobs1.includes(row.id)) {
          this.$refs.jobsTable.toggleRowSelection(row);
        }
      })
    }, 200)
  },

  async mounted() {
    this.permission = await getPermission(this.$store.state.project.id, this.$store.state.company.uid || authFirestore.currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id));
    if (!this.$store.state.project.version && !this.permission.usePermission) {
      this.permissionUser = await getPermissionByUser(this.$store.state.project.id, authFirestore.currentUser.uid, this.$store.state.project.plan && this.$store.state.project.plan.id);
    }

    const jobsResponse = await this.fire()
      .collection('jobs')
      .where('type', '==', 'JOB').get()

    const jobsData = []

    jobsResponse.forEach((job) => {
      jobsData.push({
        id: job.id,
        ...job.data()
      })
    })

    this.jobsData = [...jobsData]

    this.fetchTree();
  },

  methods: {
    rowClickJob(selected) {
      this.$emit('select-job', selected)
      this.close()
    },
    fire() {
      if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.planId)
      }

      if (this.$store.state.project.version && this.$store.state.project.version.id) {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('versions')
          .doc(this.versionId)
      }

      return myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    selectObject({id}) {
      this.objectId = id;
      this.fetchJobs();
    },
    back() {
      this.objectId = null;
    },
    fetchJobs(isFlag = false, isObject = null, uid = null) {
      return new Promise((resolve, reject) => {
        this.fire()
          .collection('jobs')
          .where('type', '==', 'JOB')
          .where(`objects`, 'array-contains-any', [isObject || this.objectId]).get()
          .then((data) => {
            const result = [];
            data.forEach((subDoc) => {
              const data = subDoc.data();

              if (isFlag) {
                result.push(
                  {
                    work_type: '',
                    comment: '',
                    job: {...data},
                    name: data.name,
                    price_unit: '',
                    unit: null,
                    total_price: '',
                    TECH: {},
                    PROF: {},
                    originalId: subDoc.id
                  }
                );
              } else {
                result.push({
                  id: subDoc.id,
                  name: data.name,
                  _data: {
                    ...data,
                  },
                  index: data.index
                });
              }
            });

            if (isFlag) {
              return resolve(_.orderBy(result, 'index', ['asc']))
            }

            this.jobs = _.orderBy(result, 'index', ['asc']);
          });
      })
    },
    async handleSelectionChangeObject(selected) {
      if (this.onlyPlan) {
        this.objectId = selected.id;
        this.fetchJobs();
      } else {
        this.selectedObjects = selected;
        this.availableObjects = this.list.filter((s) => {
          return this.selectedObjects.find((l) => l.id === s.id)
        });
      }


      if (Array.isArray(this.availableJobs)) {
        this.availableJobs = {};
      }

      let jobsIds = []

      this.availableObjects.forEach(({id}) => {
        jobsIds.push(id)
      })


      const availableJobsPrepare = {}

      this.availableObjects.forEach((obj) => {
        if (!availableJobsPrepare[obj.id]) {
          availableJobsPrepare[obj.id] = []
        }

        if(this.availableJobs[obj.id]) {
          availableJobsPrepare[obj.id] = this.availableJobs[obj.id]
        } else {
          availableJobsPrepare[obj.id] = this.jobsData.filter((job) => job.objects && job.objects.includes(obj.id))
        }
      })
      this.availableJobs = {...availableJobsPrepare}
    },
    handleSelectionChangeJob(selected) {
      setTimeout(() => {
        this.selectedJob = selected;

        const available = [];
        if (Array.isArray(this.availableJobs)) {
          this.availableJobs = {};
        }

        if (!this.availableJobs[this.objectId]) {
          this.availableJobs[this.objectId] = []
        }

        this.availableJobs[this.objectId].map((d) => {
          if (this.selectedJob.find((s) => d.id === s.id)) {
            available.push(d);
          }
        })

        this.availableJobs[this.objectId] = [...available, ...this.jobs.filter((s) => {
          return this.selectedJob.find((l) => l.id === s.id);
        })];
      }, 500)

    },
    fetchTree() {
      this.loader = true;
      const result = [];
      this.fire()
        .collection('objects')
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              objects: data.objects,
              index: data.index,
              parentId: data.parentId || undefined,
              isParent: data.isParent,
            });
          });
        }).finally(() => {
        this.list = [
          {
            id: 'all',
            name: 'Корневой каталог',
            index: 0,
            isParent: true,
          },
          ..._.orderBy(filterObjects(filterObjects(getChildList(result), this.permission), this.permissionUser), 'index', ['asc'])
        ];
        this.loader = false;
      }).catch(() => {
        this.loader = false;
      });
    },
    async save() {
      this.loading = true;
      const availableJobs = this.availableJobs;
      const availableObjects = this.availableObjects

      // '/onParsePlanVersionByFilteredJobs'
      const objects = []

      for (let object of availableObjects) {
        const uid = uuidv4()
        const jobs = await this.fetchJobs(true, object.id, uid)
        objects.push({
          id: uid,
          mainId: object.id,
          index: object.index,
          name: object.name,
          jobs: jobs,
          isSelect: true,
        })
      }

      const mainJobs = []

      Object.values(availableJobs).map((r) => {
        r.forEach(({_data}) => mainJobs.push(_data))
      })


      if (mainJobs.length) {
        objects.push({
          id: null,
          index: null,
          name: null,
          parentId: null,
          jobs: mainJobs,
        })
      }

      this.$emit('update', {
        availableJobs,
        availableObjects
      });
      if (this.objectId) {
        return this.objectId = null;
      } else {
        this.close();
      }
      // });
    },
    close() {
      this.dialogObject = false;
      this.clear();
    },
    clear() {
      this.objectId = null;
      this.selectedJob = [];
      this.selectedObjects = [];
      this.search = '';
    },
  },
};
</script>

<style scoped lang="scss">

.add-jobs {
  display: flex;
  flex-direction: column;

  .jobs-ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 8px;
  }

  .jobs-li {
    padding: 0 10px;
    width: calc(100% - 20px);
    justify-content: flex-start;
    height: 48px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    &.link {
      display: flex;
      justify-content: center;
      margin-top: 10px;

      a {
        color: #3676CB;
        text-decoration: none;
      }

      &:hover {
        background: rgba(0, 0, 0, 0);
      }
    }

    &:hover {
      background: #eee;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .select-value {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    .input-with-select {
      margin-top: 12px;
    }

    > > > {
      .el-select .el-input {
        width: 142px;
      }
    }
  }
}

.create-footer {
  margin-top: 22px;
  display: flex;
  justify-content: space-between;
}

.jobs-core {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding: 15px 15px;
}

.name-slot {
  display: flex;
  justify-content: space-between;
}

.red {
  color: #cc3700;
}

.analytic-row {
  display: flex;

  strong {
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Versions/components/PermissionObject.vue